export default `# Requirements & Personas

This panel automatically extracts user personas and product requirements from your session conversation. As the discussion evolves, new personas and user stories are identified and added.

---

## Stats Overview

Four cards summarise what's been captured:
- **Personas** — User archetypes identified (with "new" count)
- **User Stories** — Requirements extracted (with "new" count)
- **High Priority** — Critical stories that need attention
- **New Items** — Total new discoveries since last review

---

## Personas

Each persona card shows:
- **Name and role** — The user archetype (e.g. "Sarah, Product Manager")
- **NEW badge** — Recently discovered persona
- **Description** — Who this person is and what they do
- **Goals** — What they're trying to achieve
- **Pain Points** — Current frustrations and blockers
- **Timestamps** — When first identified and last updated

Personas are extracted from the conversation — when avatars discuss user types, demographics, or stakeholder groups, the AI identifies and catalogues them.

---

## User Stories

Each story follows the standard format: *"As a [persona], I want [feature], so that [benefit]"*

Stories include:
- **Priority badge** — High (red), Medium (amber), or Low (gray)
- **NEW badge** — Recently extracted
- **Linked persona** — Which persona needs this
- **Acceptance criteria** — Definition of done (checklist items)
- **Timestamps** — When first captured and last updated

---

## Actions

- **Export** — Download all personas and stories as CSV or JSON
- **Refresh** (Extract Now) — Trigger a fresh extraction from the latest conversation
- **Delete** — Remove irrelevant personas or stories (hover to reveal)

The panel also auto-refreshes extraction approximately every 5 minutes during an active session.

---

## Additional Sections

If detected, two collapsible sections may appear:
- **Technical Specs** — Core technical requirements and functionality
- **Session Assumptions** — Facts or constraints assumed during discussion

---

## Tips

- **Review "new" items regularly** — New personas and stories appear as the conversation progresses
- **Delete noise early** — Remove irrelevant extractions to keep the list focused
- **Export before the session ends** — Capture everything for your product backlog
- **High-priority stories** often come from pain points — pay special attention to these`;
